// extracted by mini-css-extract-plugin
export default {"pdfLink":"PdfLink_pdfLink__jy8el"};